import './style.css';

// Chakra-ish size names → ring diameter. Callers have always passed size='md'
// etc.; until now the component silently ignored them.
const SIZES = { xs: 14, sm: 20, md: 30, lg: 44, xl: 60 };

// A caller's `color` may be a Chakra token ('brand.500', 'accent.gold') or a
// real CSS color. Tokens are not valid CSS, so translate them to the theme's
// CSS variable — that also keeps the ring correct in both color modes.
const toCssColor = (color) =>
	/^[a-zA-Z][\w]*\.[\w.]+$/.test(color)
		? `var(--chakra-colors-${color.replace(/\./g, '-')})`
		: color;

/**
 * App-wide loading ring. ~137 call-sites pass `color`/`size`; both were
 * ignored for years (the ring was a fixed 30px indigo donut regardless).
 * Purely presentational — no behavior.
 */
const Spinner = ({ color, size, thickness }) => {
	const px = SIZES[size] || (typeof size === 'number' ? size : SIZES.md);
	const ring = thickness || Math.max(3, Math.round(px / 6));

	const style = {
		width: `${px}px`,
		height: `${px}px`,
		borderWidth: `${ring}px`,
	};
	if (color) style.borderTopColor = toCssColor(color);

	return <div className='loader' style={style}></div>;
};

export default Spinner;
